export default __webpack_public_path__ + "static/media/plus-dark.7a04c6b8.svg";